import { render, staticRenderFns } from "./RetornoExpurgo.vue?vue&type=template&id=425b2bf6&"
import script from "./RetornoExpurgo.vue?vue&type=script&lang=js&"
export * from "./RetornoExpurgo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports